import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN ?? "eec4a28ea63e089225ec7905299eef1d";

let initialized = false;

export function initAnalytics() {
  if (!MIXPANEL_TOKEN || initialized) return;
  mixpanel.init(MIXPANEL_TOKEN, {
    api_host: "https://api-eu.mixpanel.com",
    track_pageview: "url-with-path",
    persistence: "localStorage",
    autocapture: true,
    record_sessions_percent: 100,
    record_mask_all_text: false,
    record_mask_all_inputs: false,
    debug: import.meta.env.DEV,
  });
  initialized = true;
}

export function identifyUser(userId: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  mixpanel.identify(userId);
  if (properties) {
    mixpanel.people.set(properties);
  }
}

export function track(event: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  mixpanel.track(event, properties);
}

export function trackPageView() {
  if (!initialized) return;
  const params = new URLSearchParams(window.location.search);
  const utm = {
    utm_source: params.get("utm_source") ?? undefined,
    utm_medium: params.get("utm_medium") ?? undefined,
    utm_campaign: params.get("utm_campaign") ?? undefined,
    utm_term: params.get("utm_term") ?? undefined,
    utm_content: params.get("utm_content") ?? undefined,
  };
  mixpanel.track("Page View", {
    page_url: window.location.href,
    page_path: window.location.pathname,
    page_title: document.title,
    referrer: document.referrer || undefined,
    referrer_domain: document.referrer ? new URL(document.referrer).hostname : undefined,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    browser_language: navigator.language,
    dark_mode: window.matchMedia("(prefers-color-scheme: dark)").matches,
    // UTM params — only present when coming from a campaign link
    ...Object.fromEntries(Object.entries(utm).filter(([, v]) => v !== undefined)),
  });
}

export function resetAnalytics() {
  if (!initialized) return;
  mixpanel.reset();
}
